import { render } from "./SkeletonLoader.vue?vue&type=template&id=5c4af6e6&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=5c4af6e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4af6e6"]])

export default __exports__